<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<div class="img_container">
<img alt="images" src="images/copy1.jpg"/>
</div>
<h2 class="toc1"><a id="page_3"></a><a href="#/xhtml/04_General_information"><span class="bold">General information</span></a></h2>
<h2 class="toc"><a href="#/xhtml/04_General_information#sec1">Equipment</a></h2>
<h2 class="toc"><a href="#/xhtml/04_General_information#sec2">Fabrics</a></h2>
<h2 class="toc"><a href="#/xhtml/04_General_information#sec3">Fabric requirements</a></h2>
<h2 class="toc"><a href="#/xhtml/04_General_information#sec4">Interfacings and interlinings</a></h2>
<h2 class="toc"><a href="#/xhtml/04_General_information#sec5">Machine sewing thread</a></h2>
<h2 class="toc"><a href="#/xhtml/04_General_information#sec6">Patterns</a></h2>
<h2 class="toc"><a href="#/xhtml/04_General_information#sec7">Transferring markings</a></h2>
<h2 class="toc1"><span href="#/xhtml/05_Techniques" title="Link target outside of Sample"><span class="bold">Techniques</span></span></h2>
<h2 class="toc"><span href="#/xhtml/05_Techniques#sec8" title="Link target outside of Sample">Binding</span></h2>
<h2 class="toc"><span href="#/xhtml/05_Techniques#sec9" title="Link target outside of Sample">Blocking and shaping</span></h2>
<h2 class="toc"><span href="#/xhtml/05_Techniques#sec10" title="Link target outside of Sample">Gathering</span></h2>
<h2 class="toc"><span href="#/xhtml/05_Techniques#sec11" title="Link target outside of Sample">Heirloom sewing</span></h2>
<h2 class="toc"><span href="#/xhtml/05_Techniques#sec12" title="Link target outside of Sample">Piping</span></h2>
<h2 class="toc"><span href="#/xhtml/05_Techniques#sec13" title="Link target outside of Sample">Pleating</span></h2>
<h2 class="toc"><span href="#/xhtml/05_Techniques#sec14" title="Link target outside of Sample">Pressing</span></h2>
<h2 class="toc"><span href="#/xhtml/05_Techniques#sec15" title="Link target outside of Sample">Seams</span></h2>
<h2 class="toc"><span href="#/xhtml/05_Techniques#sec16" title="Link target outside of Sample">Understitching</span></h2>
<h2 class="toc"><span href="#/xhtml/05_Techniques#sec17" title="Link target outside of Sample">Topstitching</span></h2>
<h2 class="toc1"><span href="#/xhtml/06_Construction" title="Link target outside of Sample"><span class="bold">Construction</span></span></h2>
<h2 class="toc"><span href="#/xhtml/06_Construction#sec18" title="Link target outside of Sample">Assembling the garment</span></h2>
<h2 class="toc"><span href="#/xhtml/06_Construction#sec19" title="Link target outside of Sample">Armholes</span></h2>
<h2 class="toc"><span href="#/xhtml/06_Construction#sec20" title="Link target outside of Sample">Button bands</span></h2>
<h2 class="toc"><span href="#/xhtml/06_Construction#sec21" title="Link target outside of Sample">Collars</span></h2>
<h2 class="toc"><span href="#/xhtml/06_Construction#sec22" title="Link target outside of Sample">Fasteners</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Constructiona#sec23" title="Link target outside of Sample">Hems</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Constructiona#sec24" title="Link target outside of Sample">Inserts</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Constructiona#sec25" title="Link target outside of Sample">Interfacings</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Constructiona#sec26" title="Link target outside of Sample">Linings</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Constructiona#sec27" title="Link target outside of Sample">Necklines</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Constructiona#sec28" title="Link target outside of Sample">Plackets</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Constructiona#sec29" title="Link target outside of Sample">Sashes, belts and cummerbunds</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Constructiona#sec30" title="Link target outside of Sample">Sleeves</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Constructiona#sec31" title="Link target outside of Sample">Your finished garment</span></h2>
<h2 class="toc1"><span href="#/xhtml/08_Index" title="Link target outside of Sample"><span class="bold">Index</span></span></h2>
<div class="img_container">
<img alt="images" src="images/pg3-1.jpg"/>
</div>
<div class="img_container">
<img alt="images" src="images/pg3-2.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?e0a1fb0a